import { useContext } from "react";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { AgentData } from "context/Agent/DataProvider";
import { useRowPagination } from "hooks/useRowPagination";
import { Disclosure, Transition } from "@headlessui/react";

import RowPagination from "components/General/RowPagination";
import PaymentRow from "components/Payments/Billing/PaymentRow";

const PaymentTab = ({ payment, policy }) => {
  const { t } = useTranslation();
  const { agentPolicies } = useContext(AgentData);
  const [paymentHistories, setPaymentHistories] = useState(
    payment.paymentHistories
  );

  useEffect(() => {
    setPaymentHistories(payment.paymentHistories);
  }, [payment]);

  const {
    rowsForDisplay: paymentHistoryRows,
    rowPaginationProps: rowPaginationProps1,
  } = useRowPagination(paymentHistories);

  return (
    <div className="ui-component-spacing mt-6">
      <Disclosure>
        {({ open }) => (
          <div className="mt-6 xl:mt-8">
            <h3>
              <Disclosure.Button className="group px-2 text-lg text-left flex items-start justify-start hover:text-theme-action-hover">
                <span className="flex-none no-underline mt-[.375rem] mr-4">
                  <svg
                    className="ui-icon w-4 h-4 text-theme-action group-hover:text-theme-action-hover"
                    focusable="false"
                    aria-hidden="true"
                    role="presentation"
                  >
                    <use
                      href={`#${open ? "ui-icon-minus" : "ui-icon-plus"}`}
                    ></use>
                  </svg>
                </span>
                <span className="font-body font-semibold text-lg md:text-2xl">
                  {t("AgentPaymentTab-transaction-btn")}
                </span>
              </Disclosure.Button>
            </h3>
            <hr className="ui-under-title" />
            <Transition
              show={open}
              enter="transition duration-200 ease-out"
              enterFrom="transform scale-y-0 opacity-0"
              enterTo="transform scale-y-100 opacity-100"
              leave="transition duration-200 ease-out"
              leaveFrom="transform scale-y-100 opacity-100"
              leaveTo="transform scale-y-0 opacity-0"
            >
              {paymentHistories.find((ph) => ph.type === "Disbursed") && (
                <div className="flex justify-end">
                  {t("AgentPaymentTab-gross-disbursement")}
                </div>
              )}
              <Disclosure.Panel className="overflow-hidden transition-all ease-in-out duration-300">
                {paymentHistoryRows.map((item) => (
                  <PaymentRow
                    key={`payment row - ${JSON.stringify(item)}`}
                    data={item}
                    type="history"
                    policies={agentPolicies}
                  />
                ))}
                <RowPagination {...rowPaginationProps1} />
              </Disclosure.Panel>
            </Transition>
          </div>
        )}
      </Disclosure>
    </div>
  );
};

export default PaymentTab;
